import { render } from "./accordions.vue?vue&type=template&id=a01289fc"
import script from "./accordions.vue?vue&type=script&lang=js"
export * from "./accordions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__